import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOskInvitationToJoinVm } from '../osk-invitation-to-join-vm.model';
import { IOskInvitationToJoinIm } from '../osk-invitation-to-join-im.model';
@Injectable({ providedIn: 'root' })
export class OskInvitationToJoinService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OskInvitationToJoin`;
  }
  post(oskInvitationToJoinIm: IOskInvitationToJoinIm): Observable<IOskInvitationToJoinVm> {
    const headers = this.createHeaders();
    return this.http.post<IOskInvitationToJoinVm>(this.baseUrl, oskInvitationToJoinIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
